/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ColorTextInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function ColorTextInput({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/Theme/PrimaryDark/ColorTextInput",
  onChange,
  isInvalid
  
}) {
let settingsThemeoverrideDarkValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'themeOverride.dark',
})
let settingsThemeoverrideDarkIsValidData = fromData.useDataIsValid({ viewPath,
context: 'settings',
path: 'themeOverride.dark',
validate: fromValidate.color,
})
let settingsThemeoverrideDarkChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'themeOverride.dark',
})
  return (<React.Fragment
>
<TysiaInputField
  viewPath={`${viewPath}/TysiaInputField`}
 data="settings.themeOverride.dark"
 value={settingsThemeoverrideDarkValueData}
 onChange={settingsThemeoverrideDarkChangeData}
 validate="/Data/validate.js color"
 invalid={!settingsThemeoverrideDarkIsValidData}
/>
{children}
</React.Fragment>)
}